import { defineComponent as _defineComponent } from 'vue'
import ThumbsUpMan from './images/thumbs-up-man.vue.svg';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { BravadoButtonV3Size } from '~/components/common/BravadoButtonV3/types';

export default /*#__PURE__*/_defineComponent({
  __name: 'PublicPortfolioPostsEmptySection',
  setup(__props) {


return { __sfc: true,ThumbsUpMan, BravadoButtonV3, BravadoButtonV3Size }
}

})